import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/user.svg";
var UserOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  UserOutline_default as default
};
